
import React, { CSSProperties } from 'react';
import * as messages from '@radnuc/messages';
import './ModalityFilterDisplay.css';
import { Textfit } from 'react-textfit';

import chem_alert_logo from '@radnuc/react-ui-components/dist/img/icon-chem-green.png'
import bio_alert_logo from '@radnuc/react-ui-components/dist/img/icon-biohazard-darkorange.png'
import rad_alert_logo from '@radnuc/react-ui-components/dist/img/icon-radiation-white.png'
import alert_logo from '@radnuc/react-ui-components/dist/img/icon-attention.png'
import network_alert_logo from './img/icon-network-blue.png'
import { InvTypeToShow } from './BioInvestigationEncounterDisplay';

//******************************************************************************
//Select language button
export enum ModalitySelectEnum {NONE,NODE,NETWORK,ALL}
export const ModalitySelectEnumToString = ['NONE','NODE','NET','ALL'];
enum ModalityEnum {RAD,CHEM,BIO};
export interface ModalityFilterSetting {rad?:ModalitySelectEnum, chem?:ModalitySelectEnum, bio?:ModalitySelectEnum};
export interface ModalityFilterInterface { currentSetting:ModalityFilterSetting, set: (newSetting:ModalityFilterSetting) => void}
export interface ModalityFilterDisplayProps {modalityFilterInterface?:ModalityFilterInterface, modality?: ModalityEnum, style?: CSSProperties}
export interface ModalityFilterDisplayState {select_dropdown_show:boolean}

export class ModalityFilterDisplay extends React.Component<ModalityFilterDisplayProps> {
    constructor(props: ModalityFilterDisplayProps) {
        super(props)
    }

    render(){
        return(
            <div className="inv-metric-container" style={{marginTop:'5px', marginBottom:'5px', overflow:'hidden',width:'unset'}}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                <label className="metric-title" style={{height:'1.5em',lineHeight:'1.5em'}}>
                    <Textfit mode="single" forceSingleModeWidth={true} max={12} min={8}>
                        Displayed Alerts
                    </Textfit>
                </label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <ModalityFilterDisplayButton modality={ModalityEnum.RAD} modalityFilterInterface={this.props.modalityFilterInterface}/>
                    <ModalityFilterDisplayButton modality={ModalityEnum.CHEM} modalityFilterInterface={this.props.modalityFilterInterface}/>
                    <ModalityFilterDisplayButton modality={ModalityEnum.BIO} modalityFilterInterface={this.props.modalityFilterInterface}/>
                </div>
                </div>
            </div>

        )
    }
}

export class ModalityFilterDisplayButton extends React.Component<ModalityFilterDisplayProps,ModalityFilterDisplayState,{}> {
    timeoutTimer: NodeJS.Timeout | null;

    constructor(props: ModalityFilterDisplayProps) {
        super(props)
        this.state = {
            select_dropdown_show: false
        }
        this.timeoutTimer = null;
        this.handleOpenClick = this.handleOpenClick.bind(this);
        //this.handleSelectLanguage = this.handleSelectLanguage.bind(this);
    }

    componentDidUpdate(prevProps: ModalityFilterDisplayProps) {
        //This sets the language for the react-ui-components
        if(this.props.modalityFilterInterface !== undefined){
        }
    }

    componentWillUnmount(){
        if(this.timeoutTimer !== null){
            clearTimeout(this.timeoutTimer);
        }
    }

    handleOpenClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            select_dropdown_show: !state.select_dropdown_show
        }));

        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        if (!this.state.select_dropdown_show) {
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    select_dropdown_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);

        }
    }

    handleSelect(event: React.MouseEvent<HTMLElement>, select:string) {
        event.stopPropagation();
        this.setState(state => ({
            select_dropdown_show: false
        }));

        if(this.props.modalityFilterInterface !== undefined){
            //i18n.changeLanguage(language);
            let current_modalitySetting = this.props.modalityFilterInterface.currentSetting;
            let new_modalitySetting = {rad:current_modalitySetting.rad, chem:current_modalitySetting.chem, bio:current_modalitySetting.bio,}
            if(this.props.modality === ModalityEnum.RAD){
                new_modalitySetting.rad = ModalitySelectEnumToString.indexOf(select);
            } else if(this.props.modality === ModalityEnum.CHEM){
                new_modalitySetting.chem = ModalitySelectEnumToString.indexOf(select);
            } else if(this.props.modality === ModalityEnum.BIO){
                new_modalitySetting.bio = ModalitySelectEnumToString.indexOf(select);
            }
            this.props.modalityFilterInterface.set(new_modalitySetting);
            console.log(current_modalitySetting)
            console.log(new_modalitySetting)
        }

    }
    getCurrentSetting(){
        let result:ModalitySelectEnum|undefined = ModalitySelectEnum.NONE;
        if(this.props.modalityFilterInterface !== undefined){
            let current_modalitySetting = this.props.modalityFilterInterface.currentSetting;
            if(this.props.modality === ModalityEnum.RAD){
                result = current_modalitySetting.rad;
            } else if(this.props.modality === ModalityEnum.CHEM){
                result =  current_modalitySetting.chem;
            } else if(this.props.modality === ModalityEnum.BIO){
                result =  current_modalitySetting.bio;
            } else {
                result =  ModalitySelectEnum.NONE;
            }
        }
        return result;
    }

    render() {

        let current_selection = this.getCurrentSetting();

        if(current_selection === undefined){
            return <></>
        }

        let drowpdownMenuItems:JSX.Element[] = [];
        let selectList = ModalitySelectEnumToString;
        selectList.forEach((select,idx) => {
            let thisMenuItem =
                <div key={idx} className="inv-menu-item" onClick={e=>this.handleSelect(e,select)}>
                    {select.toUpperCase()}
                </div>
            drowpdownMenuItems.push(thisMenuItem);
        });

        let select_dropdown;
        if (this.state.select_dropdown_show) {
            select_dropdown =
                <div className="inv-share-dropdown-container inv-menu-item" style={{ display: 'flex', position: 'absolute' }}>
                    <div className="plot-title dropdown share-dropdown-surrogate"></div>
                    <div id="modality-select-dropdown-content" className="dropdown-content share-dropdown show" style={this.props.style}>
                        {drowpdownMenuItems}
                    </div>
                </div>
        }
        let menu_status;

            menu_status = <div id="modality-select-dropdown" style={{ height:'20px',paddingTop:'2px',paddingRight:'2px',cursor:'pointer',color:'#A0A0A0'}}>{ModalitySelectEnumToString[current_selection].toUpperCase()}</div>

        let select_button =
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <div id="modality-select-dropdown" className="dropdown" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    {select_dropdown}
                    <div className="inv-share-container inv-menu-item" style={{marginLeft:'3px'}}>
                        {menu_status}
                    </div>
                </div>
            </div>
        let mode_img;
        if(this.props.modality === ModalityEnum.RAD){
            mode_img = <div className="inv-type-indicator-img" style={{marginRight:'0px',padding:'0px'}}>
                <img style={{background:'rbg(40,40,40)'}} className="inv-type-img" src={rad_alert_logo}/>
            </div>
        } else if(this.props.modality === ModalityEnum.CHEM){
            mode_img = <div className="inv-type-indicator-img" style={{marginRight:'0px',padding:'0px'}}>
                <img style={{background:'rbg(40,40,40)'}} className="inv-type-img" src={chem_alert_logo}/>
            </div>
        } else if(this.props.modality === ModalityEnum.BIO){
            mode_img = <div className="inv-type-indicator-img" style={{marginRight:'0px',padding:'0px'}}>
                <img style={{background:'rbg(40,40,40)'}} className="inv-type-img" src={bio_alert_logo}/>
            </div>
        }
        return (
            <div className="inv-metric-container2" style={{width:'80px', marginTop:'0px', marginBottom:'0px', margin:'1px',overflow:'hidden', padding:'0px'}}  onClick={this.handleOpenClick}>
                <div className="filter-display-container" style={{ display: 'flex', flexDirection: 'row', alignItems:'center' }}>
                <div className="inv-type-indicator-img" style={{marginRight:'5px'}}>
                    {mode_img}
                </div>
                {select_button}
                </div>
            </div>

        )
    }
}

export function getInvToShowFromModalityFilterSetting(setting:ModalityFilterSetting){
    let invTypeToShow: InvTypeToShow|null = [];
    if(setting.rad !== undefined){
        if(setting.rad === ModalitySelectEnum.NODE){
            invTypeToShow.push(messages.Encounter.EncounterType.RAD);
        } else if(setting.rad === ModalitySelectEnum.NETWORK){
            invTypeToShow.push(messages.Encounter.EncounterType.RN_FUSION);
        } else if(setting.rad === ModalitySelectEnum.ALL){
            invTypeToShow.push(messages.Encounter.EncounterType.RAD);
            invTypeToShow.push(messages.Encounter.EncounterType.RN_FUSION);
        }
    }
    if(setting.chem !== undefined){
        if(setting.chem === ModalitySelectEnum.NODE){
            invTypeToShow.push(messages.Encounter.EncounterType.CHEM);
        } else if(setting.chem === ModalitySelectEnum.NETWORK){
            invTypeToShow.push(messages.Encounter.EncounterType.CHEMSIGMA);
        } else if(setting.chem === ModalitySelectEnum.ALL){
            invTypeToShow.push(messages.Encounter.EncounterType.CHEM);
            invTypeToShow.push(messages.Encounter.EncounterType.CHEMSIGMA);
        }
    }
    if(setting.bio !== undefined){
        if(setting.bio === ModalitySelectEnum.NODE){
            invTypeToShow.push(messages.Encounter.EncounterType.BIO);
        } else if(setting.bio === ModalitySelectEnum.NETWORK){
            invTypeToShow.push(messages.Encounter.EncounterType.BIOSIGMA);
        } else if(setting.bio === ModalitySelectEnum.ALL){
            invTypeToShow.push(messages.Encounter.EncounterType.BIO);
            invTypeToShow.push(messages.Encounter.EncounterType.BIOSIGMA);
        }
    }
    if(invTypeToShow.length === 0)
        invTypeToShow = [];

    return invTypeToShow;

}

//******************************************************************************
